/* eslint-disable import/prefer-default-export */
export const messageTypes = {
  changeOrganizationUnit: "changeOrganizationUnit",
  changeFirstNameOrLastName: "changeFirstNameOrLastName",
  turnOnCalculator: "turnOnCalculator",
  turnOnAutoAssignGdOnEmployeeCreate: "turnOnAutoAssignGdOnEmployeeCreate",
};
